import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ContextMenuPlugin } from '@/plugins/context-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { backgroundSetItem } from './background-set-item';

const ImageLayerContentMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').addContextMenu([
            {
                key: 'backgroundSet',
                group: 1,
                sort: 3,
                render: backgroundSetItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'image-layer-content-menu',
    render() {
        return <ImageLayerContentMenuView />;
    },
};

export default exportPlugin;
